module.exports = __webpack_public_path__ + "static/media/icon-isotipo.630a8817.svg";